<template>
  <div>
    <NavBar id="navBar" />
    <router-view id="page" />
  </div>
</template>

<style lang="scss">
  @import "./src/styles/theme";
  #page, #navBar {
    font-family: $font1;
    font-size: 20px;
  }

  #page {
    position: absolute;
    top: $navBarHeight;
    width: 100%;
    left: 0;
  }
</style>
<script>
import NavBar from '@/components/NavBar'
export default {
  components: { NavBar }
}
</script>
